/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ServiceDetailsAppLayout as ServicedeskServiceDetailsType } from '@jira/spa-apps__servicedesk-service-details-with-project-context/src/ServiceDetailsAppLayout.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskServiceDetailsWithProjectContext: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ServicedeskServiceDetailsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-service-details-with-project-context", jiraSpaEntry: "async-servicedesk-service-details-with-project-context" */ '@jira/spa-apps__servicedesk-service-details-with-project-context/src/ServicedeskServiceDetailsWithProjectContext.tsx'
		),
	),
);

const AsyncServicedeskServiceDetailsWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskServiceDetailsWithProjectContext}
		pageId="spa-apps/servicedesk/service-details"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskServiceDetailsWithProjectContext;
